// extracted by mini-css-extract-plugin
export default {"wrapper":"loaderMessage_wrapper__d-5am","message":"loaderMessage_message__kxyHs"};